import React, { useState, useEffect } from "react";
import {
  fetchAsyncInquiry,
  fetchAsyncUpdateComment,
  fetchAsyncUpdateCompleted,
  InquiryInfo,
} from "./InquirySlice";
import { InquiryData } from "./InquiryType";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { RootState } from "../../redux/store";
import "../../css/Inquiry.css";
import { DateConverter } from "../../utils/DateConverter";

interface InquiryCompleteProps {
  data: InquiryData[];
  detailFlag: boolean;
  setDetailFlag: (item: boolean) => void;
  setSelectedItem: (item: any) => void;
  handleDetail: (item: any) => void;
}

const InquiryComplete: React.FC<InquiryCompleteProps> = ({
  data,
  detailFlag,
  setDetailFlag,
  setSelectedItem,
  handleDetail,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [isEditing, setIsEditing] = useState(null); //編集するアイテム
  const [editingText, setEditingText] = useState(); //その内容
  const [editingField, setEditingField] = useState(""); //編集するセル

  //詳細ページに飛ぶ
  const jumpToDetail = (item: any) => {
    history.push("/user_detail", { user_id: item });
  };

  const handleTextChange = (event: any) => {
    setEditingText(event.target.value);
  };
  //ダブルクリックで編集モードに
  const handleDoubleClickComment = (item: any, field: any) => {
    setIsEditing(item.inquiry_id);
    setEditingField(field);
    setEditingText(item[field]);
  };
  const handleDoubleClickCompleted = (item: any, field: any) => {
    setIsEditing(item.inquiry_id);
    setEditingField(field);
    setEditingText(item[field]);
  };

  const handleKeyPressComment = async (event: any, item: any) => {
    if (event.keyCode === 13) {
      if (!event.isComposing) {
        event.preventDefault();
        const updatedData = {
          id: item.inquiry_id,
          [editingField]: editingText,
        };
        await dispatch(fetchAsyncUpdateComment(updatedData));
        setIsEditing(null);
        setEditingField("");
        await dispatch(fetchAsyncInquiry());
      }
    }
  };

  const statusOptions = [
    { value: "0", label: "未着手" },
    { value: "1", label: "対応中" },
    { value: "2", label: "対応完了" },
  ];

  const handleKeyPressCompleted = async (event: any, item: any) => {
    if (event.keyCode === 13) {
      if (!event.isComposing) {
        event.preventDefault();
        const updatedData = {
          id: item.inquiry_id,
          [editingField]: editingText,
        };
        await dispatch(fetchAsyncUpdateCompleted(updatedData));
        setIsEditing(null);
        setEditingField("");

        await dispatch(fetchAsyncInquiry());
      }
    }
  };

  return (
    <>
      {data &&
        data.map((item: any) => (
          <tr key={item.inquiry_id} className="inquiry_item_container">
            <td className="inquiry_all_box">{item.inquiry_id}</td>
            <td
              className="inquiry_all_item"
              onClick={() => handleDetail(item)}
              onDoubleClick={() => jumpToDetail(item.user_id)}>
              {item.family_name + " " + item.first_name}
            </td>
            <td className="inquiry_all_item">{item.category_description}</td>
            <td className="inquiry_all_item">{item.title}</td>
            <td className="inquiry_all_item">{item.contents}</td>
            <td className="inquiry_all_item">
              {DateConverter(item.created_at)}
            </td>
            <td>
              {isEditing === item.inquiry_id && editingField === "completed" ? (
                <select
                  value={editingText}
                  onChange={handleTextChange}
                  onKeyDown={(e) => handleKeyPressCompleted(e, item)}
                  autoFocus>
                  {statusOptions.map((option) => (
                    <option value={option.value}>{option.label}</option>
                  ))}
                </select>
              ) : (
                <div
                  onDoubleClick={() =>
                    handleDoubleClickCompleted(item, "completed")
                  }>
                  {item.status_description}
                </div>
              )}
            </td>
            <td>
              {isEditing === item.inquiry_id && editingField === "comment" ? (
                <textarea
                  value={editingText}
                  onChange={handleTextChange}
                  onKeyDown={(e) => handleKeyPressComment(e, item)}
                  autoFocus
                />
              ) : (
                <div
                  onDoubleClick={() =>
                    handleDoubleClickComment(item, "comment")
                  }>
                  {item.comment}
                </div>
              )}
            </td>
          </tr>
        ))}
    </>
  );
};
export const selectInquiry = (state: RootState) => state.Inquiry.inquiry;

export default InquiryComplete;
